import {
  cond, curry, dissoc, identity, ifElse, is, map, pipe, reduce, toPairs, T,
} from 'ramda';

const dissocDeep = curry((keyToRemove, valueToClean) => {
  const clean = ifElse(
    is(Object),
    pipe(
      dissoc(keyToRemove),
      toPairs,
      reduce(
        (acc, [key, value]) => ({
          ...acc,
          [key]: dissocDeep(keyToRemove, value),
        }),
        {},
      ),
    ),
    identity,
  );

  return cond([
    [Array.isArray, map(clean)],
    [is(Object), clean],
    [T, identity],
  ])(valueToClean);
});

export default dissocDeep;
